export default __webpack_public_path__ + "static/media/emerge.65ef9981.svg";